export default class ClienteTelefone {

  constructor(
    IdCliente = null,
    IdClienteTelefone = null,
    TipoTelefone = 'GERAL',
    Descricao = '',
    Contato = ''
  ) {
    this.IdCliente = IdCliente;
    this.IdClienteTelefone = IdClienteTelefone;
    this.TipoTelefone = TipoTelefone;
    this.Descricao = Descricao;
    this.Contato = Contato;
  }
  
}